export default {
  scoreCard: {
    score: "امتیاز",
    copyToast: "کد تخفیف کپی شد."
  },
  infoCard: {
    accountSetting: "تنظیمات حساب",
    deposit: "واریز",
    withdrawal: "برداشت",
    totalAssetsValue: "ارزش کل دارایی ها",
    profitOrLossAmount: "سود/زیان کل",
    totalAssetsValueMain: "دارایی اصلی",
    profitOrLossMain: "دارایی اسپات"
  },
  referralCard: {
    introduceToFriends: "معرفی به دوستان",
    inviteGetExcoin: "دوستات رو دعوت کن، اکسکوین بگیر",
    referralCode: "کد معرف",
    referralLink: "لینک دعوت",
    referralCodeCopied: "کد معرف کپی شد",
    referralLinkCopied: "لینک دعوت کپی شد"
  },
  pmCard: {
    tradePerfectMoney: "خرید/فروش پرفکت مانی",
    perfectMoneyDesc:
      "در این بخش می توانید به خرید و فروش پرفکت مانی خود بپردازید."
  },
  scoresCard: {
    scoresTitle: "جشنواره کولاک اکسکوینو",
    scoresDescription:
      "مجموع امتیازات شما در جشنواره کولاک اکسکوینو تا ابتدای امروز"
  },
  authorizationCard: {
    authorizationNotCompleted: "احراز هویت شما تکمیل نشده است",
    completeAuthDesc:
      "با تکمیل احراز هویت خود، می‌توانید واریز و برداشت ریالی داشته باشید.",
    completeAuthorization: "تکمیل احراز هویت"
  },
  marketBanner: {
    newLabel: "جدید",
    excoinoTrader: "اکسکوینو مارکت",
    market: "مارکت",
    tradeCurrenciesWithExcoino:
      "اکسکوینو مارکت، بازار معاملات پیشرفته رمز ارزها"
  },
  transactionsCard: {
    lastTransactions: "آخرین تراکنش‌‌ها",
    didNoneTransactions: "هیچ تراکنشی انجام نداده اید",
    fromPrice: "از",
    toPrice: "به"
  },
  ticketsCard: {
    lastTickets: "آخرین تیکت‌ها",
    noMessages: "هیچ پیامی ندارید"
  },
  currenciesCard: {
    lastListedCryptos: "آخرین رمز ارزهای لیست شده",
    lastAddedCryptos: "آخرین رمز ارز‌هایی که به اکسکوینو افزوده شده‌اند."
  },
  discountCard: {
    title: "کد هدیه",
    description: "کد هدیه مورد نظر را در کادر زیر وارد کنید.",
    buttonTitle: "اعمال",
    inputPlaceholder: "کد هدیه",
    tnxForSupportText: "از همراهی شما با اکسکوینو سپاس‌گزاریم",
    friendshipText: "این دوستی ادامه دارد",
    goToWalletText: "برو به کیف پول",
    understoodBtn: "متوجه شدم",
    yourCodeConfirmed:
      "کد مورد نظر شما اعمال شد، مبلغ زیر در بخش استخرهای مشارکت شما سرمایه گذاری شد.",
    priceAdded:
      "به پاس قدرانی از همراهی شما با اکسکوینو، مبلغ زیر به کیف پول شما اضافه شد."
  },
  guideCard: {
    pannelGuideTitle: "راهنمای کار با پنل اکسکوینو",
    pannelGuideText: "اگر در کار با پنل اکسکوینو نیاز به راهنمایی دارید"
  }
};
